import { cn } from '@bridebook/aura';
import { PropsWithChildren } from 'react';

type TypographyProps = PropsWithChildren<{
  className?: string;
}>;

export const Header1 = ({ children, className }: TypographyProps) => (
  <h1
    className={cn(
      'my-0 text-center leading-[120%]',
      // small gotcha: cn helper function has some issues with complex variable syntax
      // the setting below works. Details here: https://tailwindcss.com/docs/font-size#using-a-custom-value
      'text-[var(--ww-palette-text-primary)]',
      'text-(length:--font-header-1-size) @screen-lg:text-(length:--font-header-1-size-desktop)',
      'font-[family-name:var(--font-header-typeface)]',
      'font-(weight:--font-header-weight)',
      className,
    )}>
    {children}
  </h1>
);

export const Header2 = ({ children, className }: TypographyProps) => (
  <h2
    className={cn(
      'my-0 text-center leading-[120%]',
      'text-[var(--ww-palette-text-primary)]',
      'text-(length:--font-header-2-size) @screen-lg:text-(length:--font-header-2-size-desktop)',
      'font-[family-name:var(--font-header-typeface)]',
      'font-(weight:--font-header-weight)',
      className,
    )}>
    {children}
  </h2>
);

export const Header3 = ({ children, className }: TypographyProps) => (
  <h3
    className={cn(
      'my-0 text-center leading-[130%]',
      'text-[var(--ww-palette-text-primary)]',
      'text-(length:--font-header-3-size) @screen-lg:text-(length:--font-header-3-size-desktop)',
      'font-[family-name:var(--font-header-typeface)]',
      'font-(weight:--font-header-weight)',
      className,
    )}>
    {children}
  </h3>
);

export const SubheaderText = ({ children, className }: TypographyProps) => (
  <p
    className={cn(
      'my-0 text-center leading-[120%]',
      'text-[var(--ww-palette-text-secondary)]',
      'text-(length:--font-body-size) @screen-lg:text-(length:--font-body-size-desktop)',
      'font-[family-name:var(--font-body-typeface)]',
      'font-(weight:--font-subheader-weight)',
      className,
    )}>
    {children}
  </p>
);

type BodyTextProps = TypographyProps & {
  weight?: 'default' | 'subheader';
};

export const BodyText = ({ children, className, weight = 'default' }: BodyTextProps) => (
  <p
    className={cn(
      'my-0 text-center leading-[140%] break-words [word-break:break-word] whitespace-pre-line',
      'text-[var(--ww-palette-text-secondary)]',
      'text-(length:--font-body-size) @screen-lg:text-(length:--font-body-size-desktop)',
      'font-[family-name:var(--font-body-typeface)]',
      weight === 'default' && 'font-(weight:--font-body-weight)',
      weight === 'subheader' && 'font-(weight:--font-subheader-weight)',
      className,
    )}>
    {children}
  </p>
);
